import React from "react";
import "./ExperienceComponent.css";

const ExperienceComponent = () => {
  return (
    <>
      {/* <!-- The Timeline --> */}

      <ul className="timeline">
        {/* <!-- Item 1 --> */}
        <li>
          <div className="direction-r">
            <div className="flag-wrapper">
              <span className="flag">Placement Coordinator</span>
              <span className="time-wrapper">
                <span className="time">Mar 2023 - Jun 2024</span>
              </span>
            </div>
            <div className="desc">Training & Placement Cell, JGEC</div>
          </div>
        </li>

        {/* <!-- Item 2 --> */}
        <li>
          <div className="direction-l">
            <div className="flag-wrapper">
              <span className="flag">Event Manager</span>
              <span className="time-wrapper">
                <span className="time">January 2024 - April 2024</span>
              </span>
            </div>
            <div className="desc">JECLAT (Cultural Fest, JGEC)</div>
          </div>
        </li>

        {/* <!-- Item 2 --> */}
        <li>
          <div className="direction-r">
            <div className="flag-wrapper">
              <span className="flag">Elementary Lead</span>
              <span className="time-wrapper">
                <span className="time">January 2024 - April 2024</span>
              </span>
            </div>
            <div className="desc">JECLAT (Cultural Fest, JGEC)</div>
          </div>
        </li>

        {/* <!-- Item 3 --> */}
        <li>
          <div className="direction-l">
            <div className="flag-wrapper">
              <span className="flag">Cashier</span>
              <span className="time-wrapper">
                <span className="time">December 2022 - February 2024</span>
              </span>
            </div>
            <div className="desc">Center for Innovations Club, JGEC</div>
          </div>
        </li>
      </ul>
    </>
  );
};

export default ExperienceComponent;
